export const clubColor = {

    primary: "#f2efe4"
}